import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=159c98ff&scoped=true&"
import script from "./Payroll.vue?vue&type=script&lang=ts&"
export * from "./Payroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159c98ff",
  null
  
)

export default component.exports